import { render } from "./BerandaView.vue?vue&type=template&id=671dda2e"
import script from "./BerandaView.vue?vue&type=script&lang=js"
export * from "./BerandaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__